import { CardContent } from "@material-ui/core";
import WorkIcon from "@material-ui/icons/Work";
import React from "react";
import {
  Datagrid,
  EditButton,
  ExportButton,
  FilterButton,
  FilterList,
  FilterListItem,
  FunctionField,
  List,
  TextField,
  TextInput,
  TopToolbar,
} from "react-admin";
import { ImportButton } from "react-admin-import-csv";
import { FilterSidebar } from "lib/components/FilterSidebar";
import { HelpInfo } from "lib/components/HelpInfo";
import { colors, semanticColors } from "lib/constants/colors";
import { LoginAsUserField } from "./components/LoginAsUserField";
import { ExportPIIField } from "./components/ExportPIIField";
import { ResetPasswordField } from "./components/ResetPasswordField";
import { UserIcon } from "../index";
import { DeleteUserAuthField } from "./components/DeleteUserAuthField";
import { useUserListStyles } from "./styles";
import { SubscriptionStatusBadge } from "../components/SubscriptionStatusBadge";

const userFilters = [
  <TextInput label="UID" source="uid" alwaysOn style={{ minWidth: "340px" }} />,
  <TextInput
    label="Email"
    source="email"
    alwaysOn
    style={{ minWidth: "200px" }}
  />,
  <TextInput label="ID" source="id" style={{ minWidth: "340px" }} />,
];

const getStatusColor = (status) => {
  switch (status) {
    case "active":
      return colors.mintColor[7]; // Clean mint for active
    case "in_trial":
      return colors.skyColor[5]; // Sky blue for trial
    case "canceled":
      return colors.redMagenta[5]; // Red magenta for canceled
    case "paused":
      return colors.softOrange[5]; // Soft orange for paused
    case "non_renewing":
      return colors.mediumPurple[3]; // Medium purple for non-renewing
    default:
      return semanticColors.text; // Default text color
  }
};

export function UserList(props) {
  return (
    <List
      {...props}
      perPage={10}
      bulkActionButtons={false}
      filters={userFilters}
      actions={<UserListActions />}
      aside={<UserFilterSidebar />}
    >
      <Datagrid>
        <TextField source="email" label="Email" sortable={false} />
        <FunctionField
          label="IDs"
          render={(record) => (
            <div>
              <div>
                <strong>UID: </strong>
                <div
                  onClick={() => {
                    navigator.clipboard.writeText(record.uid);
                  }}
                >
                  {record.uid}
                </div>
              </div>
              <div>
                <strong>ID: </strong>
                <div
                  onClick={() => {
                    navigator.clipboard.writeText(record.id);
                  }}
                >
                  {record.id}
                </div>
              </div>
            </div>
          )}
        />
        <FunctionField
          label="Subscription"
          render={(record) => {
            if (!record.primarySubscription) {
              return <SubscriptionStatusBadge />;
            }
            const { status, provider, id } = record.primarySubscription;
            return (
              <div>
                <div style={{ marginBottom: "8px" }}>
                  <strong>Status: </strong>
                  <SubscriptionStatusBadge status={status} />
                </div>
                <div>
                  <strong>Provider: </strong>
                  {provider.name}
                </div>
                <div>
                  <strong>Provider ID: </strong>
                  {provider.id}
                </div>
                <div>
                  <strong>ID: </strong>
                  <span
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      navigator.clipboard.writeText(id);
                    }}
                  >
                    {id}
                  </span>
                </div>
              </div>
            );
          }}
        />
        <LoginAsUserField />
        <ExportPIIField />
        <ResetPasswordField />
        <DeleteUserAuthField />
        <EditButton
          label="Edit User"
          icon={<WorkIcon />}
          basePath="/users"
          color="secondary"
        />
      </Datagrid>
    </List>
  );
}

function UserListActions() {
  return (
    <TopToolbar style={{ display: "flex", alignItems: "center" }}>
      <FilterButton />
      <ExportButton />
    </TopToolbar>
  );
}

function UserFilterSidebar() {
  const classes = useUserListStyles();
  return (
    <FilterSidebar>
      <CardContent className={classes.filterCard}>
        <div className={classes.helpButton}>
          <HelpInfo
            helpInfos={[
              ["Filters"],
              [
                "Role",
                "This is the user's role, which defines which permissions they have.",
              ],
              [
                "Has Community Access",
                "Determines whether or not the user has access to community features.",
              ],
            ]}
          />
        </div>
        <FilterList label="Role" icon={<UserIcon />}>
          <FilterListItem label="Admin" value={{ role: "admin" }} />
        </FilterList>
        <FilterList label="Has Community Access" icon={<UserIcon />}>
          <FilterListItem label="Yes" value={{ hasCommunityAccess: true }} />
          <FilterListItem label="No" value={{ hasCommunityAccess: false }} />
        </FilterList>
      </CardContent>
    </FilterSidebar>
  );
}
